import Container from "../../components/Container";
import Button from "../../components/Button";
import { Link } from "react-router-dom";
import styles from "../order/index.module.scss";
import { Helmet } from "react-helmet-async";

export default function OrderPage() {
    return (
        <>
            <Helmet>
                <title>404 - ページが見つかりません | 西部ガス</title>
                <meta
                    name="description"
                    content="お探しのページは見つかりませんでした。URLが間違っているか、このページは移動・削除された可能性があります。"
                />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <div className={styles.orderPage}>
                <section className={styles.orderPage__errorSection}>
                    <Container>
                        <p
                            style={{
                                fontSize: "3.2rem",
                                textAlign: "center",
                            }}
                            className="noto-sans-jp-bold"
                        >
                            お探しのページは
                            <br />
                            見つかりませんでした。
                        </p>
                        <p
                            style={{
                                fontSize: "2rem",
                                lineHeight: "1.8",
                                margin: "4rem 3rem 6rem",
                                textAlign: "center",
                            }}
                            className="noto-sans-jp-medium"
                        >
                            URLが間違っているか、このページは
                            <br />
                            移動・削除された可能性があります。
                        </p>
                        <div>
                            <Button
                                variant="white"
                                className="noto-sans-jp-bold"
                            >
                                <Link
                                    to="/pr_tableconro"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <span>テーブルコンロ</span>
                                    <span>専用サイトに戻る</span>
                                </Link>
                            </Button>
                            <Button
                                variant="white"
                                className="noto-sans-jp-bold"
                            >
                                <Link to="/pr_fh" style={{ display: "flex", flexDirection: "column" }}>
                                    <span>ガスファンヒーター</span>
                                    <span>専用サイトに戻る</span>
                                </Link>
                            </Button>
                        </div>
                    </Container>
                </section>
            </div>
        </>
    );
}
